import React, { useState, useMemo, useEffect, useCallback } from 'react';
import { Flex, Container, LoadingOverlay } from '@mantine/core';
import { useSelector } from 'react-redux';
import LeftPanel from './Components/LeftPanel';
import FullCalendarWidget from './Components/FullCalendarWidget';
import BreachRecordDetailModal from './Components/BreachRecordDetailModal';
import { getBreachRecordListQuery } from '../../helpers/breach_record/api_helper';
import { convertBreachesToCalendarEvents } from './utils/taskHelpers';

const Calendar = () => {
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [isLoading, setIsLoading] = useState(false);
    const [breachData, setBreachData] = useState([]);
    const [selectedBreach, setSelectedBreach] = useState(null);
    const [modalOpened, setModalOpened] = useState(false);

    const handleBreachClick = (breach) => {
        setSelectedBreach(breach);
        setModalOpened(true);
    };

    const handleCloseModal = () => {
        setModalOpened(false);
        setSelectedBreach(null);
    };

    const handleSaveModal = () => {
        handleCloseModal();
        fetchBreachData();
    };
    const { user: profileUser } = useSelector(state => state.Profile);

    const fetchBreachData = useCallback(async () => {
        if (!profileUser?._id) return;
        try {
            setIsLoading(true);

            const queryParams = {
                populate: [
                    'breach_category',
                    'breach_impact',
                    'breach_risk_classification',
                    'breach_status',
                    'breach_type_of_evidence',
                    'breach_responsible_area',
                    'inspection_type',
                    'activity_status',
                    'responsible_user'
                ],
                filters: {
                    disable: { $eq: false },
                },
                pagination: { page: 1, pageSize: 1000 },
                sort: ['breach_date:desc'],
            };

            const result = await getBreachRecordListQuery(queryParams);
            const data = result.data || result;
            const allBreaches = Array.isArray(data) ? data : [];
            const isMab = ['MAB', 'ADM'].includes(profileUser?.role_code);
            setBreachData(
                isMab
                    ? allBreaches
                    : allBreaches.filter(b =>
                        b.responsible_user?._id === profileUser._id ||
                        b.responsible_user_id === profileUser._id
                    )
            );
        } catch (error) {
            console.error('Error fetching breach records:', error);
        } finally {
            setIsLoading(false);
        }
    }, [profileUser?._id]);

    useEffect(() => {
        fetchBreachData();
    }, [fetchBreachData]);

    const calendarEvents = useMemo(() => {
        if (!breachData || breachData.length === 0) return [];
        return convertBreachesToCalendarEvents(breachData);
    }, [breachData]);

    return (
        <Container fluid style={{ position: 'relative', padding: '0px' }}>
            <LoadingOverlay visible={isLoading} />
            <Flex gap="sm" >
                <Flex style={{ flex: 1 }}>
                    <LeftPanel 
                        selectedDate={selectedDate}
                        setSelectedDate={setSelectedDate}
                        setIsLoading={setIsLoading}
                        breachData={breachData}
                        onRefresh={fetchBreachData}
                    />
                </Flex>
                
                <Flex direction="column" style={{ flex: 1 }}>
                    <FullCalendarWidget 
                        selectedDate={selectedDate}
                        setSelectedDate={setSelectedDate}
                        events={calendarEvents}
                        onBreachClick={handleBreachClick}
                    />
                </Flex>
            </Flex>
            <BreachRecordDetailModal
                opened={modalOpened}
                onClose={handleCloseModal}
                breach={selectedBreach}
                onSave={handleSaveModal}
            />
        </Container>
    );
};

export default Calendar;